import React from 'react'
import Retour from '../components/Retour'

function Nocebo() {
  return (
    <div>
     <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Une créatrice de mode est soudain frappée par une mystérieuse maladie qui déconcerte ses médecins et contrarie son mari. Mais l’arrivée d’une nurse philippine, adepte de la médecine locale traditionnelle, révèle la terrifiante origine du mal qui la frappe.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
    </div>
  )
}

export default Nocebo